import { Skeleton } from "../Skeleton.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/skeleton/variants/TextSkeleton.tsx
const TextSkeleton = ({ children, visible, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Skeleton, {
		visible,
		"data-testid": testId,
		children
	});
};

//#endregion
export { TextSkeleton };